import { z, ZodSchema } from 'zod';


const heightError = "Please enter a valid height between 120 and 240";
const weightError = "Please enter a valid weight between 40 and 160";

export enum IVFOutcome {
    "No implantation",
    "Biochemical pregnancy",
    "Clinical pregnancy",
    "Live birth",
    "Miscarriage",
    "Ectopic pregnancy",
    "Stillbirth",
    "Multiple pregnancy"
}

export interface IVFItem {
    date: Date | null;
    outcome: IVFOutcome | null;
}

export interface FormData {
    name: string;
    birth: Date;
    height: number;
    weight: number;
    ethnicity: string[];

    type: 'natural' | 'replacement';
    start: Date;

    "endo.date": Date;
    "endo.thickness": number;
    "hormone.date": Date;
    "hormone.progesterone": number;
    "hormone.estrogen": number;

    "biopsy.date": Date;
    "biopsy.timing": 'LH+7' | 'P+5';

    cycles: IVFItem[];

    image_id: string;
}


export interface FormResponse {
    cycle: { id: string, created: string }
}

export interface GetCycleResponseImage {
}

export interface GetCycleResponseItem {

}

export interface GetCycleResponse {
    cycle: GetCycleResponseItem;
}

export const IVFItemSchema: ZodSchema<IVFItem> = z.object({
    date: z.date().nullable(),
    outcome: z.nativeEnum(IVFOutcome).nullable(),
});

export const schema: ZodSchema<FormData> = z.object({
    name: z.string(),
    birth: z.date(),
    height: z.number().min(120).max(200),
    weight: z.number().min(40).max(160),
    ethnicity: z.array(z.string()),

    type: z.enum(['natural', 'replacement']),
    start: z.date(),

    "endo.date": z.date(),
    "endo.thickness": z.number(),

    "hormone.date": z.date(),
    "hormone.progesterone": z.number(),
    "hormone.estrogen": z.number(),

    "biopsy.date": z.date(),
    "biopsy.timing": z.enum(['LH+7', 'P+5']),

    cycles: z.array(IVFItemSchema),

    image_id: z.string().uuid()
});